class CookieService {
  static getCookie = (name) => {
    const value = '; ' + document.cookie;
    const parts = value.split('; ' + name + '=');
   if (parts.length === 2) {
      return parts.pop().split(';').shift();
   }
  };
  static setCookie = (name, value, domain= '', numDays) => {
    if (!numDays) numDays = 31;
    const expires = new Date();
    expires.setTime(expires.getTime() + (1000 * 60 * 60 * 24 * numDays));
    document.cookie = `${name}=${escape(value)}; path=/; expires=${expires.toGMTString()}; domain=${domain}; Secure; SameSite=None;`;
  };
}

export default CookieService;